import React from "react";
import { useState } from "react";
import "../../style/portfolio.css";
import invoiceDesktop from "../../images/invoiceDesktop.jpg";
import invoiceMobile from "../../images/invoiceMobile.jpg";

const Invoice = () => {
  const [desktop, setDesktop] = useState(true);
  const desktopImg = () => {
    setDesktop(true);
  };
  const mobileImg = () => {
    setDesktop(false);
  };

  return (
    <div className="portfolio-element">
      <div className="portfolio-left">
        <img
          src={desktop ? invoiceDesktop : invoiceMobile}
          alt="launch countdown"
        />
        <br />
        <button
          className={desktop ? "btn-active" : "btn-inactive"}
          onClick={desktopImg}
        >
          DISEÑO DESKTOP
        </button>
        <button
          className={desktop ? "btn-inactive" : "btn-active"}
          onClick={mobileImg}
        >
          DISEÑO MOVIL
        </button>
      </div>
      <div className="portfolio-right">
        <h1 className="headings-portfolio">Invoice App</h1>
        <p>
          Para este desafío, se ha usado React (para construir el sitio),
          Node.js (Base De Datos), styled-components (para el estilo), React
          Hook Forms (para el formulario), Framer Motion (para la página
          transiciones y animaciones) y varias bibliotecas más para simplificar
          el contenido.
        </p>
        <a target="blank" href="https://invoice-app-challenge.netlify.app/">
          <button className="btn-visitar">Ver proyecto</button>
        </a>
        <a target="blank" href="https://github.com/khanchandanivikas/invoice">
          <button className="btn-visitar">Ver codigo</button>
        </a>
      </div>
    </div>
  );
};

export default Invoice;
